import React from 'react';

// http axios
import axios from 'axios';
import axiosUrl from '../../../axios/url';



export default function BlogViewerDialog(param) {

    // 콘텐츠 정보 가져오기
    async function getContent(id){

        var url = axiosUrl.blogs + '/' + id;
        await axios.get(url)
        .then( res => {
            document.getElementById('viewer').innerHTML = res.data.blog.body;
        })
        .catch(function (e) {
            alert('존재하지 않는 콘텐츠입니다. 확인 후 다시 시도하세요.');
            window.location.href='/signin';
        });
    }


    React.useEffect(() => {
        const id = param.id;

        if( id === '' || id === null) window.location = '/';
        else getContent(param.id);
    });

    return(
        <div className="modal fade" id="BlogViewerDialog" data-keyboard="false" data-backdrop="static"  tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content">
                    <div className="m-5" id="viewer"></div>
                    <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" >닫기</button>
                </div>
                 </div>
            </div>
        </div>
    );
}